export const REQUEST_DETAILS_STRINGS = {
  title: 'Request details',
  licenseeName: 'Name of Licensee',
  distributionMethod: 'Distribution method',
  publicationTitle: 'Title of Publication',
  publicationDescription: 'Publication Description',
  isAcademicJournalOrMagazine: "Whether it's an Academic Journal or Magazine",
  arrangerEditorPublication: 'Arranger/Editor',
  distributionTerritory: 'Distribution territory',
  publisher: 'Publisher',
  publicationType: 'Publication type',
  publicationAuthorArrangerEditor: 'Author',
  additionalInfo: 'Additional info',
  dateCreated: 'Date created',
  reprint: 'Reprint',
  yes: 'Yes',
  no: 'No',
  plannedPublicationDate: 'Publication date',
  edition: 'Edition',
  publisherInNorthAmerica: 'Publisher in North America',
  originalReleaseDate: 'Original release date',
  comments: 'Comments',
  componentList: 'Distribution',
  productType: 'Type',
  numberOfUnits: 'Print run',
  netRetailPrice: 'Retail price',
  numberOfSongs: 'Number of Songs',
  royaltyRate: 'Royalty Rate',
  numberOfLicensedSongs: 'Number of Licensed Songs',
  files: 'Files',
  nA: 'N/A',
  format: 'Format',
  printRun: 'Print Run',
  retailPrice: 'Retail Price',
} as const
